export default __webpack_public_path__ + "static/media/July2010.e64be9d7.png";